import { useMediaQuery } from '@mui/material';
import GlobalPopUp from './globalPopUp';
import VoiceAIPopup from '../../pages/ruleBasedInbox/threadView/components/voiceAI/voiceAIPopup';
import VoiceCallSlideTransition from './voiceCallSlideTransition';
import { useVoiceCallStore } from '../../store/voiceCallStore';
import styles from '../../assets/styles/componentStyles/voiceAgentStyles/voiceAgent.module.scss';
import { useShallow } from 'zustand/react/shallow';

const GlobalOutboundCallPopup = () => {
    const flagSmallScreen = useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1000px)');

    const { flagVoiceCallPopup, setFlagVoiceCallPopup, flagVoiceCallInboundPopup } = useVoiceCallStore(useShallow((state) => ({
        flagVoiceCallPopup: state.flagVoiceCallPopup,
        setFlagVoiceCallPopup: state.setFlagVoiceCallPopup,
        flagVoiceCallInboundPopup: state.flagVoiceCallInboundPopup
    })))

    const handleCloseOutboundCallPopup = () => {
        setFlagVoiceCallPopup(false);
    };

    return (
        <GlobalPopUp
            open={flagVoiceCallPopup && !flagVoiceCallInboundPopup}
            handleClose={handleCloseOutboundCallPopup}
            onClose={handleCloseOutboundCallPopup}
            flagShowCloseIcon={false}
            flagBackdrop
            titlePadding="0px"
            paperMinWidth={flagSmallScreen ? '310px' : '440px'}
            paperMaxwidth={flagSmallScreen ? '440px' : '440px'}
            borderRadius="20px"
            className={styles.inboundCallDialog}
            TransitionComponent={VoiceCallSlideTransition}
            TransitionProps={{ appear: true }}
            sx={{
                '& .MuiBackdrop-root': {
                    backgroundColor: 'rgba(15, 23, 42, 0.72)',
                    backdropFilter: 'blur(8px)',
                    WebkitBackdropFilter: 'blur(8px)',
                },
            }}
            PaperProps={{
                className: styles.inboundCallDialogPaper,
            }}
        >
            <VoiceAIPopup />
        </GlobalPopUp>
    );
};

export default GlobalOutboundCallPopup;
